module.exports = __webpack_public_path__ + "img/EA210_1-1.e210a1c0.jpg";